import { ChangeEvent, FC, FocusEventHandler, memo } from 'react'
import { PlanningApplicationType } from '@leadgen/models/client'
import { CheckboxButton } from '../../../atoms/CheckboxButton'
import useStableCallback from '../../../../hooks/shared/useStableCallback'

const planningApplicationTypeMap: Record<
  PlanningApplicationType,
  { title: string; description: string }
> = {
  listed: {
    title: 'Listed',
    description: 'Listed building consent planning applications.',
  },
  unlisted: {
    title: 'Unlisted',
    description: 'Planning applications for works to unlisted properties.',
  },
}

const ApplicationTypeTile: FC<{
  planningApplicationType: PlanningApplicationType
  selected: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ planningApplicationType, selected, onChange: baseOnChange, onBlur }) => {
  const onChange = useStableCallback(() => {
    baseOnChange({
      target: { value: planningApplicationType },
    } as React.ChangeEvent<HTMLInputElement>)
  })
  return (
    <CheckboxButton
      onBlur={onBlur}
      onChange={onChange}
      value={planningApplicationType}
      checked={selected}
      label={planningApplicationTypeMap[planningApplicationType].title}
      tooltip={planningApplicationTypeMap[planningApplicationType].description}
    />
  )
}

export default memo(ApplicationTypeTile)
